// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   StaffManagementPage — hub screen
   ══════════════════════════════════════════════════════════ */

.smp-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
}

/* ── Header (styled after Peripherals header) ─────────── */
.smp-header {
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;
}

.smp-header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.smp-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.smp-back-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #45556c;
  flex-shrink: 0;
}

.smp-back-btn:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}

.smp-back-btn svg {
  width: 20px;
  height: 20px;
  color: #475569;
  transition: color 0.2s ease;
}

.smp-back-btn:hover svg {
  color: #0f172a;
}

.smp-header-text h1 {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

.smp-header-text p {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}

/* ── Body ────────────────────────────────────────────── */
.smp-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
}

/* ── Tile list ───────────────────────────────────────── */
.smp-tiles {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.smp-tile {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 18px 20px;
  border: none;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  text-align: left;
  transition: transform 0.15s, box-shadow 0.15s;
}

.smp-tile:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.smp-tile:active {
  transform: translateY(0);
}

/* Tile icon wrapper — uses CSS custom property for accent colour */
.smp-tile-icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--tile-color) 80%, #0d1b3e 20%),
    var(--tile-color)
  );
  box-shadow: 0 4px 12px color-mix(in srgb, var(--tile-color) 40%, transparent);
}

/* Fallback for browsers without color-mix */
@supports not (color: color-mix(in srgb, red 50%, blue)) {
  .smp-tile-icon {
    background: var(--tile-color);
  }
}

.smp-tile-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.smp-tile-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a2236;
  line-height: 1.3;
}

.smp-tile-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}

.smp-tile-arrow {
  flex-shrink: 0;
  color: #9ca3af;
  display: flex;
  align-items: center;
}

/* ── Tile title row (title + lock badge) ─────────────── */
.smp-tile-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ── Locked tile ─────────────────────────────────────── */
.smp-tile--locked {
  opacity: 0.75;
}

.smp-tile--locked .smp-tile-icon {
  filter: saturate(0.5);
}

.smp-tile-lock-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  background: #fef3c7;
  color: #92400e;
  flex-shrink: 0;
}

.smp-tile-role-hint {
  font-size: 11px;
  color: #b45309;
  font-weight: 500;
  margin-top: 2px;
}

/* ── Access-denied banner ────────────────────────────── */
.smp-access-error {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  max-width: 560px;
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #fef9ec;
  border: 1px solid #fde68a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.smp-access-error-icon {
  font-size: 18px;
  flex-shrink: 0;
  line-height: 1.3;
}

.smp-access-error-text {
  flex: 1;
  font-size: 13px;
  color: #78350f;
  line-height: 1.5;
}

.smp-access-error-close {
  flex-shrink: 0;
  background: none;
  border: none;
  font-size: 20px;
  color: #a16207;
  cursor: pointer;
  line-height: 1;
  padding: 0 2px;
  opacity: 0.7;
  transition: opacity 0.15s;
}

.smp-access-error-close:hover {
  opacity: 1;
}

/* ── Dark mode ───────────────────────────────────────── */
.dark .smp-root {
  background: #121827;
}

.dark .smp-header {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .smp-header-text h1 {
  color: #f8fafc;
}

.dark .smp-header-text p {
  color: #94a3b8;
}

.dark .smp-back-btn {
  background-color: #334155;
  border-color: #334155;
  color: #cbd5e1;
}

.dark .smp-back-btn:hover {
  background-color: #334155;
  color: #f8fafc;
}

.dark .smp-back-btn svg {
  color: #cbd5e1;
}

.dark .smp-back-btn:hover svg {
  color: #f8fafc;
}

.dark .smp-tile {
  background: #1a2236;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

.dark .smp-tile:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}

.dark .smp-tile-title {
  color: #e2e8f0;
}

.dark .smp-tile-desc {
  color: #94a3b8;
}

.dark .smp-tile-arrow {
  color: #4b5e76;
}

.dark .smp-tile-lock-badge {
  background: #3d2f00;
  color: #fbbf24;
}

.dark .smp-tile-role-hint {
  color: #f59e0b;
}

.dark .smp-access-error {
  background: #2d1e00;
  border-color: #78350f;
}

.dark .smp-access-error-text {
  color: #fde68a;
}

.dark .smp-access-error-close {
  color: #fbbf24;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/StaffManagementPage.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gDAAgD;EAChD;;0BAEwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX;;;;GAIC;EACD,6EAA6E;AAC/E;;AAEA,4CAA4C;AAC5C;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2DAA2D;AAC3D;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   StaffManagementPage — hub screen\n   ══════════════════════════════════════════════════════════ */\n\n.smp-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n/* ── Header (styled after Peripherals header) ─────────── */\n.smp-header {\n  background-color: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.05);\n  transition:\n    background-color 0.3s ease,\n    border-color 0.3s ease;\n}\n\n.smp-header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.smp-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.smp-back-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #45556c;\n  flex-shrink: 0;\n}\n\n.smp-back-btn:hover {\n  background-color: #e2e8f0;\n  color: #0f172a;\n}\n\n.smp-back-btn svg {\n  width: 20px;\n  height: 20px;\n  color: #475569;\n  transition: color 0.2s ease;\n}\n\n.smp-back-btn:hover svg {\n  color: #0f172a;\n}\n\n.smp-header-text h1 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #0f172a;\n  margin: 0;\n}\n\n.smp-header-text p {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n/* ── Body ────────────────────────────────────────────── */\n.smp-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 24px;\n}\n\n/* ── Tile list ───────────────────────────────────────── */\n.smp-tiles {\n  width: 100%;\n  max-width: 560px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.smp-tile {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  padding: 18px 20px;\n  border: none;\n  border-radius: 14px;\n  background: #fff;\n  cursor: pointer;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);\n  text-align: left;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.smp-tile:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n}\n\n.smp-tile:active {\n  transform: translateY(0);\n}\n\n/* Tile icon wrapper — uses CSS custom property for accent colour */\n.smp-tile-icon {\n  flex-shrink: 0;\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--tile-color) 80%, #0d1b3e 20%),\n    var(--tile-color)\n  );\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--tile-color) 40%, transparent);\n}\n\n/* Fallback for browsers without color-mix */\n@supports not (color: color-mix(in srgb, red 50%, blue)) {\n  .smp-tile-icon {\n    background: var(--tile-color);\n  }\n}\n\n.smp-tile-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.smp-tile-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a2236;\n  line-height: 1.3;\n}\n\n.smp-tile-desc {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.smp-tile-arrow {\n  flex-shrink: 0;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Tile title row (title + lock badge) ─────────────── */\n.smp-tile-title-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ── Locked tile ─────────────────────────────────────── */\n.smp-tile--locked {\n  opacity: 0.75;\n}\n\n.smp-tile--locked .smp-tile-icon {\n  filter: saturate(0.5);\n}\n\n.smp-tile-lock-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  background: #fef3c7;\n  color: #92400e;\n  flex-shrink: 0;\n}\n\n.smp-tile-role-hint {\n  font-size: 11px;\n  color: #b45309;\n  font-weight: 500;\n  margin-top: 2px;\n}\n\n/* ── Access-denied banner ────────────────────────────── */\n.smp-access-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  max-width: 560px;\n  margin-bottom: 16px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: #fef9ec;\n  border: 1px solid #fde68a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.smp-access-error-icon {\n  font-size: 18px;\n  flex-shrink: 0;\n  line-height: 1.3;\n}\n\n.smp-access-error-text {\n  flex: 1;\n  font-size: 13px;\n  color: #78350f;\n  line-height: 1.5;\n}\n\n.smp-access-error-close {\n  flex-shrink: 0;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #a16207;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0 2px;\n  opacity: 0.7;\n  transition: opacity 0.15s;\n}\n\n.smp-access-error-close:hover {\n  opacity: 1;\n}\n\n/* ── Dark mode ───────────────────────────────────────── */\n.dark .smp-root {\n  background: #121827;\n}\n\n.dark .smp-header {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .smp-header-text h1 {\n  color: #f8fafc;\n}\n\n.dark .smp-header-text p {\n  color: #94a3b8;\n}\n\n.dark .smp-back-btn {\n  background-color: #334155;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n\n.dark .smp-back-btn:hover {\n  background-color: #334155;\n  color: #f8fafc;\n}\n\n.dark .smp-back-btn svg {\n  color: #cbd5e1;\n}\n\n.dark .smp-back-btn:hover svg {\n  color: #f8fafc;\n}\n\n.dark .smp-tile {\n  background: #1a2236;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n}\n\n.dark .smp-tile:hover {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n}\n\n.dark .smp-tile-title {\n  color: #e2e8f0;\n}\n\n.dark .smp-tile-desc {\n  color: #94a3b8;\n}\n\n.dark .smp-tile-arrow {\n  color: #4b5e76;\n}\n\n.dark .smp-tile-lock-badge {\n  background: #3d2f00;\n  color: #fbbf24;\n}\n\n.dark .smp-tile-role-hint {\n  color: #f59e0b;\n}\n\n.dark .smp-access-error {\n  background: #2d1e00;\n  border-color: #78350f;\n}\n\n.dark .smp-access-error-text {\n  color: #fde68a;\n}\n\n.dark .smp-access-error-close {\n  color: #fbbf24;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
